import { RiLoader5Line } from "@remixicon/react";
import { cn } from "~/lib/utils";

interface IProps {
  className?: string;
  size?: number;
}

const Loader = ({ className, size }: IProps) => {
  return (
    <RiLoader5Line size={size} className={cn("animate-spin", className)} />
  );
};

export default Loader;
